/* eslint-disable import/prefer-default-export */

// Return FlowFetchError from graphQLErrors
export const getFlowFetchError = error => {
  if (!error.graphQLErrors) {
    return null;
  }
  const name = 'FlowFetchError';
  return error.graphQLErrors.find(e => e.name === name);
};

// Get a valid error code (integer) from an error message
// If the error message is a numeric string between 400-500 this value will be
// parsed and returned. If not, it will fall back to 500.
export const getErrorCodeFromMessage = message =>
  /^[4-5][0-9][0-9]$/.test(message) ? parseInt(message, 10) : 500;
